import { LogManager } from "@mcleod/core";
import { AutogenLayoutMobileCommFormGroupList } from "./autogen/AutogenLayoutMobileCommFormGroupList";

const log = LogManager.getLogger("lme.dispatch.mobilecomm.MobileCommFormGroupList");


export class MobileCommFormGroupList extends AutogenLayoutMobileCommFormGroupList {
}
